
import { Drawer } from "element-ui"
import { initBindCardSource } from "./checkout/bind-card.js"
import bindCard from "./checkout/bind-card.vue"
import drawerHeader from "./drawer/components/drawerHeader.vue"
import { cardList, unbindCard, getCardBrandList } from "@/api/pay.js"

export default {
  components: {
    [Drawer.name]: Drawer,
    bindCard,
    drawerHeader
  },
  data() {
    return {
      loading: false,
      cardList: [],
      visible: false,
      bindCardStatus: "init",
      cardBrandList: [],
      currentCardType: {}
    }
  },
  computed: {
    btnText() {
      return this.bindCardStatus === "init" ? this.$t("checkout.next") : this.$t("checkout.payNow")
    },
    cardTitle() {
      let title = ""
      if (this.bindCardStatus === "init") {
        title = this.$t("checkout.addNewCard")
      } else if (this.bindCardStatus === "beforeVerify") {
        title = this.$t("checkout.orderReview")
      } else if (this.bindCardStatus === "verifying") {
        title = this.$t("checkout.DSecureAuth")
      }
      return title
    }
  },
  mounted() {
    this.getCardList()
    this.getCardBrandList()
  },
  methods: {
    async getCardBrandList() {
      try {
        const res = await getCardBrandList()
        if (res.code === "0000") {
          this.cardBrandList = res.data || []
        }
      } catch (error) {
        console.log(error)
      }
    },
    async handleAddCard(val) {
      this.loading = true
      this.currentCardType = val
      await initBindCardSource(val.cardBrand)
      this.visible = true
      this.loading = false
    },
    async getCardList() {
      const { data } = await cardList({
        params: JSON.stringify({
          payWay: 800
        })
      })
      this.cardList = data || []
    },
    handleDrawerClose() {
      this.bindCardStatus = "init"
    },
    handleSave() {
      this.$refs.bindCard.onSubmit()
    },
    handleStatuChanged({ status, payload }) {
      this.bindCardStatus = status
      if (status === "done") {
        this.visible = false
        this.bindCardStatus = "init"
        this.getCardList()
      }
      if (status === "error") {
        this.visible = false
        this.bindCardStatus = "init"
      }
    },
    handleDelete(signNum) {
      this.$messageBox
        .open({
          title: this.$t("card.deleteCard"),
          message: this.$t("card.confirmText"),
          cancelText: this.$t("card.cancel"),
          confirmText: this.$t("card.confirm")
        })
        .then(res => {
          this.unbindCard(signNum)
        })
        .catch(res => {})
    },
    async unbindCard(signNum) {
      try {
        const { data } = await unbindCard({
          params: JSON.stringify({
            payWay: 800,
            signNum
          })
        })
        this.$message.success(this.$t("card.message"))
        this.getCardList()
      } catch (error) {
        console.log(error)
      }
    }
  }
}
